import { createAsyncThunk } from '@reduxjs/toolkit';
import { serviceProviderAPI } from './serviceProviderAPI';

export const fetchServiceProviders = createAsyncThunk(
  'serviceProvider/fetchServiceProviders',
  async () => {
    const response = await serviceProviderAPI.fetchServiceProviders();
    return response.data;
  }
);
